import { nodesFlux, useEditorSelector } from '@candulabs/craft';
import { useMemo } from 'react';
import { createStructuredSelector } from 'reselect';

export const useGridColumnClassNames = (id: string) => {
  const structuredSelector = useMemo(
    () =>
      createStructuredSelector({
        custom: nodesFlux.selectors.getNodeCustom(id),
      }),
    [id],
  );
  const { custom } = useEditorSelector(structuredSelector);

  const classNames: string[] = [`grid-column`];

  if (custom?.media?.columns) {
    Object.entries(custom.media.columns).forEach(([key, value]) =>
      classNames.push(`grid-column-${key}-${value}`),
    );
  }

  return classNames.join(' ');
};
